import React, { useMemo } from "react";
import { DownloadIcon } from "src/components/ui-icons/upload";
import { SearchUI } from "src/components/ui/Search";
import ExportToExcel from "src/modules/exelExport";
import { FlexRow } from "src/utils/flexLayouts";
import { WorkplaceType } from "src/pages/Reports/WorkPlaceReport/types";
import { classNames } from "src/helpers/classNames";
import { siteUrl } from "src/api/config";

type HeaderProps = {
  loading: boolean;
  searchQuery: string;
  onSearch: (query: string) => void;
  workplaces: (WorkplaceType & { collapsed: boolean })[];
};

function Header({ loading, searchQuery, onSearch, workplaces }: HeaderProps) {
  const exportData = useMemo(() => {
    if (!workplaces.length) {
      return { columns: [], data: [] };
    }

    const columns = [
      { header: "Рабочее место", key: "workplace", width: 35 },
      { header: "% ознакомления по рабочему месту", key: "workplacePercent", width: 20 },
      { header: "Код документа", key: "code", width: 20 },
      { header: "Документ", key: "document", width: 45 },
      { header: "Версия", key: "version", width: 10 },
      { header: "Критичность", key: "critical", width: 15 },
      { header: "% ознакомления", key: "docPercent", width: 18 },
      { header: "Ознакомлены", key: "familiarized", width: 45 },
      { header: "Не ознакомлены", key: "notFamiliarized", width: 45 },
      { header: "Отклонены", key: "canceled", width: 45 },
    ];

    const data = workplaces.flatMap((workplace): any[] => {
      if (!workplace.documents.length) {
        return [
          {
            workplace: workplace.title,
            workplacePercent: workplace.familiarizationPercent ?? 0,
            code: "-",
            document: "-",
            version: "-",
            critical: "-",
            docPercent: "-",
            familiarized: "-",
            notFamiliarized: "-",
            canceled: "-",
          },
        ];
      }

      return workplace.documents.map((document) => {
        const documentLink =
          document.versionId && document.mainDocumentId
            ? `${siteUrl}/dashboard/1/documents?documentCard=${document.mainDocumentId}&version=${document.versionId}`
            : `${siteUrl}/dashboard/1/documents?documentCard=${document.id}`;
        const documentData = document.name
          ? {
              text: document.name,
              hyperlink: documentLink,
              tooltip: document.name,
            }
          : "-";

        return {
          workplace: workplace.title,
          workplacePercent: workplace.familiarizationPercent,
          code: document.code || "-",
          document: documentData,
          version: document.version ?? "-",
          critical: document.critical ? "Критичный" : "Не критичный",
          docPercent: document.familiarizationPercent ?? 0,
          familiarized:
            document.familiarizedUsers.length > 0 ? document.familiarizedUsers.map((u) => u.name).join(", ") : "-",
          notFamiliarized:
            document.nonFamiliarizedUsers.length > 0
              ? document.nonFamiliarizedUsers.map((u) => u.name).join(", ")
              : "-",
          canceled: document.canceledUsers.length > 0 ? document.canceledUsers.map((u) => u.name).join(", ") : "-",
        };
      });
    });

    return { columns, data };
  }, [workplaces]);

  return (
    <FlexRow className="pt-5 pb-4 gap-x-2.5 items-end justify-end">
      {/* <SearchUI
        defaultValue={searchQuery}
        placeholder="Найти документ"
        onClick={onSearch}
        inputWrapperClass="w-full"
        emptyValue={true}
      /> */}
      <ExportToExcel
        disabled={loading}
        type="workplace_report"
        fileName="Отчёт по рабочим местам"
        exportData={exportData}
        button={{
          icon: <DownloadIcon />,
          child: "Скачать в Excel",
          classNames: classNames(
            "flex gap-x-2 justify-center items-center ml-auto text-base font-medium bg-white rounded-md border text-darkblue hover:bg-gray-50 shadow-custom whitespace-nowrap",
            loading ? "opacity-50 cursor-not-allowed" : "",
          ),
          styles: {},
        }}
      />
    </FlexRow>
  );
}

export default Header;
